import { fromJS } from "immutable";
import { SET_AUTH_TOKEN, CLEAR_AUTH_TOKEN } from "./actions";

export const initialState = fromJS({
  token: null,
});

export const API = "API";

export default function apiReducer(state = initialState, action) {
  switch (action.type) {
    case SET_AUTH_TOKEN:
      return state.setIn(["token"], action.token);
    case CLEAR_AUTH_TOKEN:
      return state.setIn(["token"], null);
    default:
      return state;
  }
}
